import React, { useEffect, useRef, useState } from "react";
import { Space, Table } from "antd";
import "../../../cssfiles/homepage.css";
import Dialog from "@mui/material/Dialog";
import {
  TextField,
  InputAdornment,
  Typography,
  Checkbox,
  FormControlLabel,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import { useSelector, useDispatch } from "react-redux";
import CheckBoxOutlinedIcon from "@mui/icons-material/CheckBoxOutlined";
import {
  getdashboardgrouplist,
  getdashboarlist,
  createdashboardgroup,
  createdashboardname,
  deletedahboard,
  updatedashboardwidgetlist,
  getdashboarddetailseditor,
} from "../../../Restclient/datacollection";
import Dashboardconfpage from "./Dashboardconfpage";
import Widgetcreateupdate from "./Widgetcreateupdate";
import Dashboardsettings from "./Dashboardsettings";
import Widgetlist from "./Widgetlist";
import { resetWidgetCreation,setEditWidgetMode,setEditWidgetId } from "../../../store/cofig_data"; 
import { generateWidgetId } from "../DashboardConfigurator/Dashboard/Widget/utils/widgetId";

const data = [];
for (let i = 0; i < 100; i++) {
  data.push({
    key: i,
    dashboardname: `Dasboard ${i}`,
    groupname: `Group ${i}`,
    createdby: `User ${i}`,
    permissions: "1111111",
  });
}

export default function Dashboardlist(props) {
  const theme = useSelector((state) => state.themedata.theme);
  const logindetails = useSelector((state) => state.logindata.userdetails);
  const basicprops = useSelector((state) => state.configdata.editbasicprops);
  const dispatch = useDispatch();
  const [adddashbdialog, setAdddashbdialog] = useState(false);
  const [dashboardname, setDashboardname] = useState("");
  const [dashboardgroup, setDashboardgroup] = useState([]);
  const [addnewgroupflag, setAddnewgroupflag] = useState(false);
  const [dashboardgroupname, setDashboardgroupname] = useState("");
  const [dashboardlist, setDashboardlist] = useState([]);
  const [selctgroupname, setSelectgroupname] = useState("");
  const [deletedashboardflag, setDeletedashboardflag] = useState(false);
  const [deletedashboard, setDeletedashboard] = useState("");
  const [dashboardconfflag, setDashboardconfflag] = useState(false);
  const [editdashboarddetails, setEditdashboarddetails] = useState({});
  const [dragflag, setDragflag] = useState(false);
  const [adddialog, setAdddialog] = useState(false);
  const [settingsdialog, setSettingsdialog] = useState(false);
  const [dilogname, setDialogname] = useState("Widget List");
  const [addwidgetflag, setAddwidgetflag] = useState(false);
  const [savedashboardflag, setSavedashboardflag] = useState(false);

  const refdashboardgroup = useRef(dashboardgroup);

   // Clone dashboard states
  const [cloneDialogOpen, setCloneDialogOpen] = useState(false);
  const [cloneSourceDashboard, setCloneSourceDashboard] = useState(null);
  const [cloneDashboardName, setCloneDashboardName] = useState("");
  const [cloneSelectGroupName, setCloneSelectGroupName] = useState("");
  const [cloneLoading, setCloneLoading] = useState(false);
  const [cloneError, setCloneError] = useState("");

  const handledeletedata = (data) => {
    setDeletedashboardflag(true);
    setDeletedashboard(data);
  };

  const handleeditdata = (data) => {
    setEditdashboarddetails(data);
    setDashboardconfflag(true);
  };

  const columns = [
    {
      title: "Dashboard Name",
      dataIndex: "dashboardname",
      //width: 150,
    },
    {
      title: "Group Name",
      dataIndex: "groupname",
      //width: 150,
    },
    {
      title: "Created By",
      dataIndex: "createdby",
    },
    {
      title: "Permissions",
      dataIndex: "permissions",
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (_, record) => (
        <Space size="middle">
          <a onClick={() => handleeditdata(record)}> Edit </a>
          <a onClick={() => handledeletedata(record)}> Delete </a>
          <a onClick={() => handleOpenCloneDialog(record)}> Clone </a>
        </Space>
      ),
    },
  ];

  const dashboardgropcallbeack = (res) => {
    var grouplist = [];
    for (let i = 0; i < res.dashboardgrouplist.length; i++) {
      grouplist.push(res.dashboardgrouplist[i]);
    }
    setDashboardgroup(grouplist);
    refdashboardgroup.current = grouplist;
  };

  const callbackdashbordlist = (res) => {

    var dashboardli = [];
    for (let i = 0; i < res.dashboardlist.length; i++) {
      var groupname = "";
      for (let j = 0; j < refdashboardgroup.current.length; j++) {
        if (
          refdashboardgroup.current[j].groupid === res.dashboardlist[i].groupid
        ) {
          groupname = refdashboardgroup.current[j].groupname;
          break;
        }
      }

      dashboardli.push({
        key: res.dashboardlist[i].dashboard_pro,
        dashboardname: res.dashboardlist[i].Dashboardname,
        groupname: groupname,
        createdby: "",
        permissions: "",
      });
    }
    setDashboardlist(dashboardli);
    /*var dlist = []
        setCurrentdashboardlist(res.dashboardlist)
        for(let i=0; i<res.dashboardlist.length; i++) {
          dlist.push({
            label: <Typography style={{fontSize: 16, color: 'var(--PrimaryText)'}}> {res.dashboardlist[i].Dashboardname} </Typography>,
            value: res.dashboardlist[i].Dashboardname
          })
        }
        setDashboarlist(dlist)*/
  };

  useEffect(() => {
    getdashboardgrouplist(
      logindetails.Organizationid,
      logindetails.Projectid,
      dashboardgropcallbeack
    );
    getdashboarlist(
      logindetails.Organizationid,
      logindetails.Projectid,
      "All",
      callbackdashbordlist
    );
  }, []);

  const handleClosedialogadddashb = () => {
    setAdddashbdialog(false);
  };

  const dashboardcallback = (res) => {
    if (res.status === "done") {
      getdashboarlist(
        logindetails.Organizationid,
        logindetails.Projectid,
        "All",
        callbackdashbordlist
      );
    } else {
      console.log("Dashboard not created");
    }
  };

  const handleAdddashboarddialog = () => {
    if (dashboardname !== "") {
      var groupid = "";
      for (let i = 0; i < dashboardgroup.length; i++) {
        if (selctgroupname === dashboardgroup[i].groupname) {
          groupid = dashboardgroup[i].groupid;
          break;
        }
      }
      if (groupid != "") {
        createdashboardname(
          logindetails.Organizationid,
          logindetails.Projectid,
          groupid,
          dashboardname,
          dashboardcallback
        );
      }
    } else {
      return;
    }
    setAdddashbdialog(false);
    setDashboardname("")
    setDashboardconfflag(true);
  };

  const handleopenadddashboard = () => {
    setAdddashbdialog(true);
  };

  const handlechnagedashboardname = (e) => {
    setDashboardname(e.target.value);
  };

  const handlecreategroup = () => {
    setAddnewgroupflag(true);
  };

  const callbackgroupcreation = (res) => {
    if (res.status === "done") {
      getdashboardgrouplist(
        logindetails.Organizationid,
        logindetails.Projectid,
        dashboardgropcallbeack
      );
    } else {
      console.log("Dashboard group not created");
    }
  };

  const handleadddashboardgroup = () => {
    createdashboardgroup(
      logindetails.Organizationid,
      logindetails.Projectid,
      dashboardgroupname,
      callbackgroupcreation
    );
    setAddnewgroupflag(false);
  };

  const handlecloseadddashboardgroup = () => {
    setAddnewgroupflag(false);
  };

  const handlechnagedashboardgroupname = (e) => {
    setDashboardgroupname(e.target.value);
  };

  const handleselectgroupname = (e) => {
    setSelectgroupname(e.target.value);
  };

  const handleClosedialogdelete = () => {
    setDeletedashboardflag(false);
  };

  const callbackdelete = (res) => {
    if (res.status === "done") {
      getdashboarlist(
        logindetails.Organizationid,
        logindetails.Projectid,
        "All",
        callbackdashbordlist
      );
    } else {
    }
  };

  const handledelettreeindex = () => {
    // deletedashboard variable previously stored may be either id or object; normalize
    let payload = deletedashboard;
    if (typeof deletedashboard === 'string') {
      payload = { key: deletedashboard };
    } else if (deletedashboard && deletedashboard.dashboard_pro) {
      payload = { key: deletedashboard.dashboard_pro, dashboardname: deletedashboard.Dashboardname || deletedashboard.dashboardname };
    } else if (deletedashboard && deletedashboard.id) {
      payload = { key: deletedashboard.id, dashboardname: deletedashboard.name };
    }
    deletedahboard(payload, callbackdelete);
    setDeletedashboardflag(false);
  };

  const handleopendashboardlist = () => {
    setDashboardconfflag(false);
  };

  const handledragdropflag = () => {
    setDragflag(!dragflag);
  };

  const handleaddnewwidget = () => {
    dispatch(setEditWidgetMode("New"));
    dispatch(setEditWidgetId(null));
    dispatch(resetWidgetCreation());
    setDialogname("Widget List");
    setAdddialog(true);
  };

  const handleCloseadddialog = () => {
    setAdddialog(false);
  };

  const handleupdatesettings = () => {
    setSettingsdialog(true);
  };

  const handleClosesettingsdialog = () => {
    setSettingsdialog(false);
  };

  const handlecallbackselection = (state, name) => {
    if (state === "main list") {
      setDialogname("Widget List");
    } else if (state === "sub list") {
      setDialogname("Widget List (" + name + ")");
    } else if (state === "props setting") {
      setDialogname("Widget Properties (" + name + ")");
    }
  };

  const handleAddwidgrttodashboard = () => {
    setAddwidgetflag(true);
    setAdddialog(false);
  };

  const handleaddwidgetfalg = () => {
    setAddwidgetflag(false);
  };

  const handlesavedashboard = () => {
    setSavedashboardflag(true);
  };

  const handlesavedashboardcallback = (flag) => {
    setSavedashboardflag(flag);
  };

   const handleOpenCloneDialog = (source) => {
    setCloneSourceDashboard(source);
    setCloneDashboardName(source.dashboardname + ' (Clone)');
    setCloneSelectGroupName(source.groupname);
    setCloneError('');
    setCloneDialogOpen(true);
  };

  const handleCloseCloneDialog = () => {
    if (cloneLoading) return; 
    setCloneDialogOpen(false);
    setCloneSourceDashboard(null);
    setCloneDashboardName('');
    setCloneSelectGroupName('');
    setCloneError('');
    setCloneLoading(false);
  };

  const finalizeClone = () => {
    getdashboarlist(
      logindetails.Organizationid,
      logindetails.Projectid,
      'All',
      callbackdashbordlist
    );
    handleCloseCloneDialog();
  };

  const handleCloneSave = () => {
    if (!cloneDashboardName || !cloneSelectGroupName) {
      setCloneError('Provide name and group.');
      return;
    }
    if (!cloneSourceDashboard) {
      setCloneError('No source selected.');
      return;
    }
    setCloneLoading(true);
    setCloneError('');
    // Resolve group id from name
    const group = dashboardgroup.find(g => g.groupname === cloneSelectGroupName);
    if (!group) {
      setCloneError('Group not found.');
      setCloneLoading(false);
      return;
    }
    const groupid = group.groupid;
    // 1. Create new dashboard
    createdashboardname(
      logindetails.Organizationid,
      logindetails.Projectid,
      groupid,
      cloneDashboardName,
      (res) => {
        const ok = res && (res.status === 'done' || res.success);
        if (!ok) {
          setCloneError(res?.message || 'Create failed');
          setCloneLoading(false);
          return;
        }
        // 2. Fetch source widgets (if backend endpoint exists)
        getdashboarddetailseditor(cloneSourceDashboard.key, (details) => {
          try {
            const root = details?.dashboardjson || details;
            const dj = root?.DashboardJSON || root?.dashboard || root;
            let list = dj?.widgetlist || dj?.widgets || root?.widgetlist || root?.widgets || [];
            if (list && list.list && Array.isArray(list.list)) list = list.list;
            if (!Array.isArray(list)) list = [];
            // 3. Normalize and clone widgets
            const existingIds = list.map(w => w.id || w.widgetid).filter(Boolean);
            const cloned = list.map((w, idx) => {
              const originalName = w.widgetname || w.props?.basic?.widgetName || w.props?.basic?.title || 'Widget';
              return {
                id: generateWidgetId(originalName + '_clone_' + idx, existingIds),
                widgetname: originalName + ' (Clone)',
                type: w.type,
                props: w.props ? JSON.parse(JSON.stringify(w.props)) : { basic: {}, extended: {} }
              };
            });
            if (!cloned.length) {
              finalizeClone();
              return;
            }
            // 4. Find new dashboard id from refreshed list
            getdashboarlist(
              logindetails.Organizationid,
              logindetails.Projectid,
              'All',
              (listRes) => {
                let newDashId = null;
                if (listRes && Array.isArray(listRes.dashboardlist)) {
                  const found = listRes.dashboardlist.find(d => d.Dashboardname === cloneDashboardName && d.groupid === groupid);
                  newDashId = found ? found.dashboard_pro : null;
                }
                if (!newDashId) {
                  setCloneError('New dashboard id not found.');
                  setCloneLoading(false);
                  return;
                }
                // 5. Persist cloned widgets
                updatedashboardwidgetlist(newDashId, cloned, (saveRes) => {
                  const wOk = saveRes && (saveRes.status === 'done' || saveRes.success);
                  if (!wOk) {
                    setCloneError(saveRes?.message || 'Widget save failed');
                    setCloneLoading(false);
                    return;
                  }
                  setCloneLoading(false);
                  finalizeClone();
                });
              }
            );
          } catch (e) {
            setCloneError('Clone failed: ' + e.message);
            setCloneLoading(false);
          }
        });
      }
    );
  };
  
   return (
    <div
      style={{
        width: "calc(100% - 25px)",
        height: "calc(100% - 20px)",
        padding: "10px",
      }}
    >

      {dashboardconfflag ? (
        <div style={{ height: "100%" }}>
          <div style={{ display: "flex", marginBottom: "10px",justifyContent: "space-between"}}>
            <div>
                Dashboard Name: {editdashboarddetails.dashboardname }
            </div>
          <div>
              <button
              style={{
                padding: "8px 20px",
                //width: '137px',
                //height: '35px',
                backgroundColor: "var(--LK_BrandBlue)",
                color: "var(--White)",
                //padding: '8px 45px',
                border: "none",
                borderRadius: "20px",
                fontSize: "16px",
                fontWeight: 700,
                fontFamily: "Roboto",
                cursor: "pointer",
                marginRight: "10px",
              }}
              onClick={handleopendashboardlist}
            >
              Back to Dashboard List
            </button>
            <button
              style={{
                padding: "8px 20px",
                //width: '137px',
                //height: '35px',
                backgroundColor: "var(--LK_BrandBlue)",
                color: "var(--White)",
                //padding: '8px 45px',
                border: "none",
                borderRadius: "20px",
                fontSize: "16px",
                fontWeight: 700,
                fontFamily: "Roboto",
                cursor: "pointer",
                marginRight: "10px",
              }}
              onClick={handleaddnewwidget}
            >
              Add Widget
            </button>
            <button
              style={{
                padding: "8px 20px",
                //width: '137px',
                //height: '35px',
                backgroundColor: "var(--LK_BrandBlue)",
                color: "var(--White)",
                //padding: '8px 45px',
                border: "none",
                borderRadius: "20px",
                fontSize: "16px",
                fontWeight: 700,
                fontFamily: "Roboto",
                cursor: "pointer",
                marginRight: "10px",
              }}
              onClick={handleupdatesettings}
            >
              Settings
            </button>
            <button
              style={{
                padding: "8px 20px",
                //width: '137px',
                //height: '35px',
                backgroundColor: "var(--LK_BrandBlue)",
                color: "var(--White)",
                //padding: '8px 45px',
                border: "none",
                borderRadius: "20px",
                fontSize: "16px",
                fontWeight: 700,
                fontFamily: "Roboto",
                cursor: "pointer",
                marginRight: "10px",
              }}
              onClick={handledragdropflag}
            >
              {dragflag ? "Stop Rearrange" : "Rearrange"}
            </button>
            <button
              style={{
                padding: "8px 20px",
                //width: '137px',
                //height: '35px',
                backgroundColor: "var(--LK_BrandBlue)",
                color: "var(--White)",
                //padding: '8px 45px',
                border: "none",
                borderRadius: "20px",
                fontSize: "16px",
                fontWeight: 700,
                fontFamily: "Roboto",
                cursor: "pointer",
                //marginRight: '10px'
              }}
              onClick={handlesavedashboard}
            >
              Save
            </button>
          </div>
          </div>
          <div style={{ height: "calc(100% - 35px)", overflow: "auto" }}>
            <Dashboardconfpage
              dashboarddetails={editdashboarddetails}
              dragflag={dragflag}
              addwidgetflag={addwidgetflag}
              callbackupdateaddflag={handleaddwidgetfalg}
              savedashboard={savedashboardflag}
              callbacksavedashboard={handlesavedashboardcallback}
            />
          </div>
        </div>
      ) : (
        <>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            <div style={{ flexGrow: 1 }}></div>
            <button
              style={{
                padding: "8px 20px",
                //width: '137px',
                //height: '35px',
                backgroundColor: "var(--LK_BrandBlue)",
                color: "var(--White)",
                //padding: '8px 45px',
                border: "none",
                borderRadius: "20px",
                fontSize: "16px",
                fontWeight: 700,
                fontFamily: "Roboto",
                cursor: "pointer",
                //marginRight: '10px'
              }}
              onClick={handleopenadddashboard}
            >
              Add Dashboard
            </button>
          </div>
          <Table
            columns={columns}
            dataSource={dashboardlist}
            pagination={false}
            /*pagination={{
                            pageSize: 50,
                        }}*/
            scroll={{
              y: 440,
            }}
            className="anttable"
          />
        </>
      )}
      <Dialog
        open={deletedashboardflag}
        onClose={handleClosedialogdelete}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{ sx: { borderRadius: "0px" } }}
      >
        <DialogTitle
          id="alert-dialog-title"
          style={{
            backgroundColor: theme === "dark" ? "#000000" : "#EFEFEF",
            color: theme === "dark" ? "#FFFFFF" : "#3C3C3C",
          }}
        >
          {"Conformation Info"}
        </DialogTitle>
        <DialogContent
          style={{
            backgroundColor: theme === "dark" ? "#000000" : "#EFEFEF",
            color: theme === "dark" ? "#FFFFFF" : "#3C3C3C",
          }}
        >
          Do you want to delete ?
        </DialogContent>
        <DialogActions
          style={{
            backgroundColor: theme === "dark" ? "#000000" : "#EFEFEF",
            color: theme === "dark" ? "#FFFFFF" : "#3C3C3C",
          }}
        >
          <button
            style={{
              padding: "6px 15px",
              //width: '137px',
              //height: '35px',
              backgroundColor: "transparent",
              color: "#7E7E7E",
              //padding: '8px 45px',
              border: "1px solid",
              borderColor: theme === "dark" ? "#7E7E7E" : "#7E7E7E",
              borderRadius: "20px",
              fontSize: "16px",
              fontWeight: 700,
              fontFamily: "Roboto",
              cursor: "pointer",
              marginRight: "10px",
            }}
            onClick={handleClosedialogdelete}
          >
            Close
          </button>
          <button
            style={{
              padding: "8px 20px",
              //width: '137px',
              //height: '35px',
              backgroundColor: "#005C8E",
              color: "#FFFFFF",
              //padding: '8px 45px',
              border: "none",
              borderRadius: "20px",
              fontSize: "16px",
              fontWeight: 700,
              fontFamily: "Roboto",
              cursor: "pointer",
            }}
            onClick={handledelettreeindex}
          >
            Delete
          </button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={adddashbdialog}
        onClose={handleClosedialogadddashb}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: {
            borderRadius: "0px",
            bgcolor: "var(--secondary-background)", //theme==='dark'?'#1E1E1E':'#FFFFFF',
            maxHeight: "850px",
            maxWidth: "600px",
            width: "1150px",
            height: "500px",
            overflowX: "none",
            overflowY: "auto",
            color: "var(--SecondaryText)", //theme==='dark'?'#C1C1C1':'#7E7E7E',
          },
        }}
      >
        <DialogTitle
          id="alert-dialog-title"
          style={{
            backgroundColor: theme === "dark" ? "#1E1E1E" : "#EFEFEF",
            color: "#005C8E",
          }}
        >
          {"Add New Dashboard"}
        </DialogTitle>
        <DialogContent
          style={{
            backgroundColor: theme === "dark" ? "#1E1E1E" : "#EFEFEF",
            color: theme === "dark" ? "#FFFFFF" : "#3C3C3C",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginTop: "20px",
            }}
          >
            <TextField
              id="Dashboardname"
              label={
                <Typography
                  style={{
                    fontSize: 20,
                    fontWeight: 500,
                    color: theme === "dark" ? "#FFFFFF" : "#3C3C3C",
                  }}
                >
                  {" "}
                  Dasboard Name{" "}
                </Typography>
              }
              variant="standard"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start"></InputAdornment>
                ),
                style: {
                  color: "var(--PrimaryText)",
                },
              }}
              sx={{
                width: "300px",
                marginBottom: "20px",
                "& .MuiInput-underline:before": {
                  borderBottomColor: "var(--PrimaryText)",
                },
              }}
              value={dashboardname}
              onChange={handlechnagedashboardname}
            />
            <div>
              <FormControl
                variant="standard"
                sx={{
                  width: "300px",
                  marginBottom: "20px",
                  marginRight: "20px",
                  marginTop: "10px",
                }}
              >
                <InputLabel id="demo-simple-select-standard-label">
                  {" "}
                  Group List
                </InputLabel>
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  value={selctgroupname}
                  onChange={handleselectgroupname}
                  label="Group List"
                  style={{
                    textAlign: "left",
                    padding: "0px",
                  }}
                  sx={{
                    border: 0,
                    width: "300px",
                    //height: '24px',
                    bgcolor: "var(--SecondaryBackground)",
                    color: "var(--GreyVariation_2)",
                    fontSize: "18px",
                    fontFamily: "Roboto",
                    fontWeight: 400,
                    textAlign: "left",
                    borderRadius: 0,
                    marginRight: "0px",
                    "& .MuiOutlinedInput-underline:before": {
                      borderBottomColor: "var(--PrimaryText)",
                    },
                    "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                      {
                        border: 0,
                      },
                    "& .MuiOutlinedInput-notchedOutline ": {
                      width: "122.35px",
                      //height:'24px',
                      border: 0,
                      padding: 0,
                    },
                    "& .MuiInputLabel-root": {
                      display: "none",
                      legend: "none",
                    },
                    "& .MuiSelect-select": {
                      paddingTop: "0px",
                      paddingBottom: "0px",
                    },
                  }}
                  InputLabelProps={{ shrink: false }}
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        bgcolor: theme === "dark" ? "#3C3C3C" : "#C1C1C1",
                        borderBottom: "2px solid #008CD7",
                        borderRadius: 0,
                        boxShadow: "none",
                        maxHeight: "250px",
                        overflow: "auto",
                        color: theme === "dark" ? "#FFFFFF" : "#3C3C3C",
                      },
                    },
                  }}
                >
                  {dashboardgroup.map((name) => {
                    return (
                      <MenuItem
                        sx={{
                          fontSize: "16px",
                          fontFamily: "Roboto",
                          fontWeight: 400,
                        }}
                        value={name.groupname}
                      >
                        {name.groupname}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
              <button
                style={{
                  padding: "8px 20px",
                  //width: '137px',
                  //height: '35px',
                  backgroundColor: "#005C8E", //'var(--LK_BrandBlue)',
                  color: "#FFFFFF",
                  //padding: '8px 45px',
                  border: "none",
                  borderRadius: "20px",
                  fontSize: "16px",
                  fontWeight: 700,
                  fontFamily: "Roboto",
                  cursor: "pointer",
                  marginRight: "10px",
                  marginTop: "15px",
                }}
                onClick={handlecreategroup}
              >
                Create New
              </button>
              {addnewgroupflag && (
                <div style={{ marginTop: "30px" }}>
                               <TextField
                    id="groupname"
                    label={
                      <Typography
                        style={{
                          fontSize: 20,
                          fontWeight: 500,
                          color: theme === "dark" ? "#FFFFFF" : "#3C3C3C",
                        }}
                      >
                        {" "}
                        Dasboard Group Name{" "}
                      </Typography>
                    }
                    variant="standard"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start"></InputAdornment>
                      ),
                      style: {
                        color: "var(--PrimaryText)",
                      },
                    }}
                    sx={{
                      width: "300px",
                      marginBottom: "20px",
                      "& .MuiInput-underline:before": {
                        borderBottomColor: "var(--PrimaryText)",
                      },
                    }}
                    value={dashboardgroupname}
                    onChange={handlechnagedashboardgroupname}
                  />
                  <button
                    style={{
                      padding: "6px 15px",
                      //width: '137px',
                      //height: '35px',
                      backgroundColor: "transparent",
                      color: "#7E7E7E",
                      //padding: '8px 45px',
                      border: "1px solid",
                      borderColor: theme === "dark" ? "#7E7E7E" : "#7E7E7E",
                      borderRadius: "20px",
                      fontSize: "16px",
                      fontWeight: 700,
                      fontFamily: "Roboto",
                      cursor: "pointer",
                      marginRight: "10px",
                      marginTop: "15px",
                      marginLeft: "20px",
                    }}
                    onClick={handlecloseadddashboardgroup}
                  >
                    Close
                  </button>
                  <button
                    style={{
                      padding: "8px 20px",
                      //width: '137px',
                      //height: '35px',
                      backgroundColor: "#005C8E", //'var(--LK_BrandBlue)',
                      color: "#FFFFFF",
                      //padding: '8px 45px',
                      border: "none",
                      borderRadius: "20px",
                      fontSize: "16px",
                      fontWeight: 700,
                      fontFamily: "Roboto",
                      cursor: "pointer",
                    }}
                    onClick={handleadddashboardgroup}
                  >
                    Add
                  </button>
                </div>
              )}
            </div>
            <div>
              <FormControlLabel
                control={
                  <Checkbox
                    checkedIcon={<CheckBoxOutlinedIcon />}
                    defaultChecked
                    sx={{
                      //padding: 0,
                      margin: 0,
                      color: "var(--HighlightedText_Stroke)",
                      "& .MuiSvgIcon-root": {
                        fontSize: "20px",
                        color: "var(--HighlightedText_Stroke)",
                      },
                    }}
                  />
                }
                label="All User"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checkedIcon={<CheckBoxOutlinedIcon />}
                    defaultChecked
                    sx={{
                      //padding: 0,
                      margin: 0,
                      color: "var(--HighlightedText_Stroke)",
                      "& .MuiSvgIcon-root": {
                        fontSize: "20px",
                        color: "var(--HighlightedText_Stroke)",
                      },
                    }}
                  />
                }
                label="Only for me"
              />
              {/*<FormControlLabel 
                                control={
                                    <Checkbox 
                                        checkedIcon={<CheckBoxOutlinedIcon />} 
                                        defaultChecked 
                                        sx={{
                                            //padding: 0,
                                            margin: 0,
                                            color: 'var(--HighlightedText_Stroke)',
                                            '& .MuiSvgIcon-root': {
                                                fontSize: '20px',
                                                color: 'var(--HighlightedText_Stroke)'
                                            }
                                        }} 
                                    />
                                }
                                label = "For Users"
                            />*/}
            </div>
          </div>
        </DialogContent>
        <DialogActions
          style={{
            backgroundColor: theme === "dark" ? "#1E1E1E" : "#EFEFEF",
            color: theme === "dark" ? "#FFFFFF" : "#3C3C3C",
          }}
        >
          <button
            style={{
              padding: "6px 15px",
              //width: '137px',
              //height: '35px',
              backgroundColor: "transparent",
              color: "#7E7E7E",
              //padding: '8px 45px',
              border: "1px solid",
              borderColor: theme === "dark" ? "#7E7E7E" : "#7E7E7E",
              borderRadius: "20px",
              fontSize: "16px",
              fontWeight: 700,
              fontFamily: "Roboto",
              cursor: "pointer",
              marginRight: "10px",
            }}
            onClick={handleClosedialogadddashb}
          >
            Close
          </button>
          <button
            style={{
              padding: "8px 20px",
              //width: '137px',
              //height: '35px',
              backgroundColor: "#005C8E",
              color: "#FFFFFF",
              //padding: '8px 45px',
              border: "none",
              borderRadius: "20px",
              fontSize: "16px",
              fontWeight: 700,
              fontFamily: "Roboto",
              cursor: "pointer",
            }}
            onClick={handleAdddashboarddialog}
          >
            Save
          </button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={adddialog}
        onClose={handleCloseadddialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: {
            borderRadius: "0px",
            bgcolor: "var(--secondary-background)", //theme==='dark'?'#1E1E1E':'#FFFFFF',
            maxHeight: "850px",
            maxWidth: "1950px",
            width: "1450px",
            height: "800px",
            overflow: "auto",
            color: "var(--SecondaryText)", //theme==='dark'?'#C1C1C1':'#7E7E7E',
          },
        }}
      >
        <DialogTitle
          id="alert-dialog-title"
          style={{
            backgroundColor: theme === "dark" ? "#000000" : "#EFEFEF",
            color: "#005C8E",
          }}
        >
          {dilogname}
        </DialogTitle>
        <DialogContent
          style={{
            backgroundColor: theme === "dark" ? "#000000" : "#EFEFEF",
            color: theme === "dark" ? "#FFFFFF" : "#3C3C3C",
          }}
        >
          <Widgetlist callbackselection={handlecallbackselection} />
          {/*<Widgetcreateupdate/>*/}
        </DialogContent>
        <DialogActions
          style={{
            backgroundColor: theme === "dark" ? "#000000" : "#EFEFEF",
            color: theme === "dark" ? "#FFFFFF" : "#3C3C3C",
          }}
        >
          <button
            style={{
              padding: "6px 15px",
              //width: '137px',
              //height: '35px',
              backgroundColor: "transparent",
              color: "#7E7E7E",
              //padding: '8px 45px',
              border: "1px solid",
              borderColor: theme === "dark" ? "#7E7E7E" : "#7E7E7E",
              borderRadius: "20px",
              fontSize: "16px",
              fontWeight: 700,
              fontFamily: "Roboto",
              cursor: "pointer",
              marginRight: "10px",
            }}
            onClick={handleCloseadddialog}
          >
            Close
          </button>
          {dilogname.includes("Widget Properties") && (
            <button
              style={{
                padding: "8px 20px",
                //width: '137px',
                //height: '35px',
                backgroundColor: "#005C8E",
                color: "#FFFFFF",
                //padding: '8px 45px',
                border: "none",
                borderRadius: "20px",
                fontSize: "16px",
                fontWeight: 700,
                fontFamily: "Roboto",
                cursor: "pointer",
              }}
              onClick={handleAddwidgrttodashboard}
            >
              Save new properties
            </button>
          )}
        </DialogActions>
      </Dialog>
      <Dialog
        open={settingsdialog}
        onClose={handleClosesettingsdialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: {
            borderRadius: "0px",
            bgcolor: "var(--secondary-background)", //theme==='dark'?'#1E1E1E':'#FFFFFF',
            maxHeight: "850px",
            maxWidth: "1950px",
            width: "1450px",
            height: "800px",
            overflow: "auto",
            color: "var(--SecondaryText)", //theme==='dark'?'#C1C1C1':'#7E7E7E',
          },
        }}
      >
        <DialogTitle
          id="alert-dialog-title"
          style={{
            backgroundColor: theme === "dark" ? "#1E1E1E" : "#EFEFEF",
            color: "#005C8E",
          }}
        >
          {"Dashboard Settings"}
        </DialogTitle>
        <DialogContent
          style={{
            backgroundColor: theme === "dark" ? "#1E1E1E" : "#EFEFEF",
            color: theme === "dark" ? "#FFFFFF" : "#3C3C3C",
          }}
        >
          <Dashboardsettings />
        </DialogContent>
        <DialogActions
          style={{
            backgroundColor: theme === "dark" ? "#1E1E1E" : "#EFEFEF",
            color: theme === "dark" ? "#FFFFFF" : "#3C3C3C",
          }}
        >
          <button
            style={{
              padding: "6px 15px",
              //width: '137px',
              //height: '35px',
              backgroundColor: "transparent",
              color: "#7E7E7E",
              //padding: '8px 45px',
              border: "1px solid",
              borderColor: theme === "dark" ? "#7E7E7E" : "#7E7E7E",
              borderRadius: "20px",
              fontSize: "16px",
              fontWeight: 700,
              fontFamily: "Roboto",
              cursor: "pointer",
              marginRight: "10px",
            }}
            onClick={handleClosesettingsdialog}
          >
            Close
          </button>
          <button
            style={{
              padding: "8px 20px",
              //width: '137px',
              //height: '35px',
              backgroundColor: "#005C8E",
              color: "#FFFFFF",
              //padding: '8px 45px',
              border: "none",
              borderRadius: "20px",
              fontSize: "16px",
              fontWeight: 700,
              fontFamily: "Roboto",
              cursor: "pointer",
            }}
            //onClick={handleAdddashboarddialog}
          >
            Save
          </button>
        </DialogActions>
      </Dialog>

      {/* Clone Dashboard Dialog */}
      <Dialog
        open={cloneDialogOpen}
        onClose={handleCloseCloneDialog}
        PaperProps={{ sx: { borderRadius: '0px', minWidth: 400 } }}
      >
        <DialogTitle style={{ backgroundColor: theme === 'dark' ? '#1E1E1E' : '#EFEFEF', color: '#005C8E' }}>
          Clone Dashboard
        </DialogTitle>
        <DialogContent style={{ backgroundColor: theme === 'dark' ? '#1E1E1E' : '#EFEFEF' }}>
          <TextField
            label="New Dashboard Name"
            variant="standard"
            fullWidth
            value={cloneDashboardName}
            onChange={(e) => setCloneDashboardName(e.target.value)}
            sx={{ mb: 3 }}
          />
          <FormControl variant="standard" fullWidth sx={{ mb: 3 }}>
            <InputLabel>Group</InputLabel>
            <Select
              value={cloneSelectGroupName}
              onChange={(e) => setCloneSelectGroupName(e.target.value)}
              label="Group"
            >
              {dashboardgroup.map(g => (
                <MenuItem key={g.groupid} value={g.groupname}>{g.groupname}</MenuItem>
              ))}
            </Select>
          </FormControl>
          {cloneError && (
            <Typography color="error" variant="body2" sx={{ mt: 1 }}>
              {cloneError}
            </Typography>
          )}
        </DialogContent>
        <DialogActions style={{ backgroundColor: theme === 'dark' ? '#1E1E1E' : '#EFEFEF' }}>
          <button
            style={{
              padding: '6px 15px',
              backgroundColor: 'transparent',
              color: '#7E7E7E',
              border: '1px solid',
              borderColor: theme === 'dark' ? '#7E7E7E' : '#7E7E7E',
              borderRadius: '20px',
              fontSize: '16px',
              fontWeight: 700,
              fontFamily: 'Roboto',
              cursor: 'pointer',
              marginRight: '10px',
            }}
            onClick={handleCloseCloneDialog}
            disabled={cloneLoading}
          >
            Close
          </button>
          <button
            style={{
              padding: '8px 20px',
              backgroundColor: '#005C8E',
              color: '#FFFFFF',
              border: 'none',
              borderRadius: '20px',
              fontSize: '16px',
              fontWeight: 700,
              fontFamily: 'Roboto',
              cursor: 'pointer',
            }}
            onClick={handleCloneSave}
            disabled={cloneLoading}
          >
            {cloneLoading ? 'Cloning...' : 'Clone'}
          </button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
